module.exports = __webpack_public_path__ + "static/media/bollard.3ec08e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/bollard.png
// module id = 211
// module chunks = 0